export default "__VITE_ASSET__3tYLYGMk__"